import welcomeTour from './welcome.tour';
import projectSetupTour from './projectSetup.tour';
import scheduleBasicsTour from './scheduleBasics.tour';
import productsCodesTour from './productsCodes.tour';
import collaborationTour from './collaboration.tour';
import revisionsExportTour from './revisionsExport.tour';
import adminSetupTour from './adminSetup.tour';
import createScheduleGuide from './createSchedule.guide';
import createProjectGuide from './createProject.guide';
import createScheduleFromProjectGuide from './createScheduleFromProject.guide';

// Order matters: the first tour whose `match` fits the current path and which
// has `autoStart` is the one offered automatically.
export const TOURS = [
  scheduleBasicsTour,
  projectSetupTour,
  productsCodesTour,
  collaborationTour,
  revisionsExportTour,
  adminSetupTour,
  welcomeTour,
];

export function getTourById(id) {
  return TOURS.find((tour) => tour.id === id);
}

// `match` is a comma separated list of path prefixes. A prefix starting with
// "!" excludes instead -- used to keep schedule-sheet tours off the schedule
// list page, which shares the same prefix but has none of the same targets.
export function matchesPath(tour, pathname) {
  const prefixes = tour.match.split(',').map((prefix) => prefix.trim());
  const isExcluded = prefixes
    .filter((prefix) => prefix.startsWith('!'))
    .some((prefix) => pathname.startsWith(prefix.slice(1)));
  if (isExcluded) return false;
  return prefixes
    .filter((prefix) => !prefix.startsWith('!'))
    .some((prefix) => pathname.startsWith(prefix));
}

export function getToursForPath(pathname) {
  return TOURS.filter((tour) => matchesPath(tour, pathname));
}

// ----------------------------------------------------------------------
// Interactive guides. Unlike tours these are not page scoped: a guide walks
// across pages, so it is offered everywhere and finds its own way.
// ----------------------------------------------------------------------

export const GUIDES = [createProjectGuide, createScheduleFromProjectGuide, createScheduleGuide];

export function getGuideById(id) {
  return GUIDES.find((guide) => guide.id === id);
}

// Whether the stage the guide is currently on belongs to this page. Several
// stages can share a page (a dialog stage sits on the same route as the page
// behind it), so this checks the current stage rather than searching for the
// first match -- otherwise a later stage on the same route is unreachable.
export function isStageOnPath(guide, stageIndex, pathname) {
  const stage = guide.stages[stageIndex];
  return Boolean(stage) && matchesPath(stage, pathname);
}
